import IntegrationStatisticWidget from './component'

export default IntegrationStatisticWidget
